import { BASE_URL } from "./apiConfig";
import Cookies from "js-cookie"; // Assuming you're using js-cookie for cookie management

export const imageUrl = BASE_URL + "/public";

export const isValidDate = (date) => {
  if (!date) return false;

  return date instanceof Date && !isNaN(date);
};

export const dateFormat = (dateString) => {
  if (!dateString) return "-";

  // Just split by 'T' and take the date part only
  return dateString.split("T")[0];
};

export const dateTimeFormat = (dateString) => {
  if (!dateString) return "-";

  // Split by 'T' and get both date and time parts
  const [date, time] = dateString.split("T");

  // Remove milliseconds from the time
  const formattedTime = time.split(".")[0];

  // Return the formatted date and time with an HTML line break
  return `${date}<br />${formattedTime}`;
};

export const dateTimeFormatN = (dateString) => {
  if (!dateString || dateString === "Still Online") return dateString || "-";

  let date = "";
  let time = "";

  if (dateString.includes("T")) {
    [date, time] = dateString.split("T");
    time = time?.split(".")[0];
  } else if (dateString.includes(" ")) {
    [date, time] = dateString.split(" ");
  } else {
    return dateString;
  }

  return `${date}, ${time || ""}`;
};

export const onlyDateFormat = (dateString) => {
  if (!dateString) return "-";

  const date = new Date(dateString);
  if (isNaN(date)) return "-";

  return date.toISOString().split("T")[0]; // Extract only the date (YYYY-MM-DD)
};

export const readableFormate = (dateString) => {
  if (!dateString) return "-";
  const options = { year: "numeric", month: "short", day: "numeric" }; //20 Sep 2025
  return new Date(dateString).toLocaleDateString(undefined, options);
};

export const onlyTimeFormat = (dateString) => {
  if (!dateString) return "-";

  const date = new Date(dateString);
  if (isNaN(date)) return "-";

  return date.toISOString().split("T")[1].split(".")[0]; // Extract only the time (HH:MM:SS)
};

// Function to set a cookie
// export function setCookie(name, value, days = 7) {
//   const expires = new Date();
//   expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
//   document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/; Secure; SameSite=Strict`;
// }

// export const setCookie = (name, value, days = 7) => {
//   let expires = "";
//   if (days) {
//     const date = new Date();
//     date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
//     expires = "; expires=" + date.toUTCString();
//   }

//   document.cookie = `${name}=${value}${expires}; path=/; Secure; SameSite=None`;
// };

export const dateTimeFormatIST = (dateString) => {
  if (!dateString) return "-";

  const date = new Date(dateString);

  if (isNaN(date)) return "-";

  const formattedDate = date.toLocaleDateString("en-CA", {
    timeZone: "Asia/Kolkata",
  });

  const formattedTime = date.toLocaleTimeString("en-GB", {
    timeZone: "Asia/Kolkata",
    hour12: false,
  });

  return {
    date: formattedDate,
    time: formattedTime,
  };
};

export const setCookie = (name, value, days = 7) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  const sameSiteFlag = "; SameSite=Lax"; // Use Lax instead of None for HTTP

  document.cookie = `${name}=${value}${expires}; path=/${sameSiteFlag}`;
};

// Utility function to clear cookies
export const clearCookies = () => {
  Cookies.remove("token"); // Replace with the actual cookie name(s) you want to clear
  Cookies.remove("user");
};

// Function to get the value of a cookie
export function getCookie(name) {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
}

export const pagesToShow = 5;

export const dataPerPage = 10;

export const validateEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

export const validatePhoneNumber = (number) => {
  const regex = /^\d{10}$/; // Assuming a 10-digit phone number
  return regex.test(number);
};

export const validatePassword = (password) => password.length >= 8;

export const isEmpty = (value) => {
  if (value === null || value === undefined) return true;
  if (typeof value === "string" && !value.trim()) return true;
  // if (Array.isArray(value) && value.length === 0) return true;
  // if (typeof value === "object" && Object.keys(value).length === 0) return true;
  return false;
};

// Common function to handle status codes and clear cookies
export const handleUnauthorizedOrForbidden = (error) => {
  console.log(error);
  if (
    error.response &&
    (error.response.status === 401 || error.response.status === 403)
  ) {
    clearCookies();
    window.location.href = "/login";
  }
  throw error;
};

export const getValue = (date) => {
  if (!date) return null;

  // If it's already a Date object
  if (date instanceof Date) {
    return date;
  }

  // If it's an ISO string or any date string
  try {
    return new Date(date);
  } catch (e) {
    console.error("Invalid date format:", date);
    return null;
  }
};

export function formatNumber(value) {
  if (value < 100000) {
    // For numbers less than 1 lakh, display the full number with commas
    return new Intl.NumberFormat("en-IN").format(value);
  } else {
    // For numbers 1 lakh and above, use compact notation
    return new Intl.NumberFormat("en-IN", {
      notation: "compact",
      compactDisplay: "short",
      maximumFractionDigits: 2,
    }).format(value);
  }
}

export const reviewLength = 100;
